import MainLayout from "../components/MainLayout";
import Separator from "../components/Separator";
import Typography from "../components/Typography";
import {
    RequireEmissionsSourceEvidenceTable,
    RequireOrganizationEvidenceTable,
} from "../components/RequiredEvidenceTable";
import Button from "../components/Button";
import { useState } from "react";

const RequiredEvidencePage = () => {
    const [selectedTab, setSelectedTab] = useState<
        "emissionsSources" | "organization"
    >("emissionsSources");

    return (
        <MainLayout>
            <div className="pt-8 px-5">
                <Typography
                    variant="display-small"
                    component="h1"
                    className="text-deep-ocean-20"
                >
                    Evidence
                </Typography>
            </div>
            <div className="flex space-x-4 p-5">
                <Button
                    variant={
                        selectedTab === "emissionsSources"
                            ? "primary"
                            : "outline"
                    }
                    onClick={() => setSelectedTab("emissionsSources")}
                >
                    Emissions sources
                </Button>
                <Button
                    variant={
                        selectedTab === "organization" ? "primary" : "outline"
                    }
                    onClick={() => setSelectedTab("organization")}
                >
                    Organization
                </Button>
            </div>
            <Separator />
            <div className="px-5 py-2">
                {selectedTab === "emissionsSources" ? (
                    <RequireEmissionsSourceEvidenceTable noEvidenceMessage="No evidence expiring within selected range" />
                ) : (
                    <RequireOrganizationEvidenceTable />
                )}
            </div>
        </MainLayout>
    );
};

export default RequiredEvidencePage;
